var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4697 20.5303C12.7626 20.8232 13.2374 20.8232 13.5303 20.5303L18.3033 15.7574C18.5962 15.4645 18.5962 14.9896 18.3033 14.6967C18.0104 14.4038 17.5355 14.4038 17.2426 14.6967L13 18.9393L8.75736 14.6967C8.46447 14.4038 7.98959 14.4038 7.6967 14.6967C7.40381 14.9896 7.40381 15.4645 7.6967 15.7574L12.4697 20.5303ZM12.25 5L12.25 20L13.75 20L13.75 5L12.25 5Z",
    fill: "#FFD4A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRoute);
export default __webpack_public_path__ + "static/media/ico_route.0d1b47d6c2dba16e8238cb6c04dbf208.svg";
export { ForwardRef as ReactComponent };